import React from 'react'
import NavMobile from './NavMobile/NavMobile'
import NavDesktop from './NavDesktop/NavDesktop'
import NavPayments from './NavPayments'
import { connect } from 'react-redux'
import DataSource from '../DataSource'

class Navigation extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            items: {}
        }
    }

    componentDidMount () {
        DataSource.getData('/api/nav', result => {
            this.setState({
                items: result.items
            }, this.setActiveStates)
        })
    }

    resetNavigation () {
        this.forceUpdate()
        this.setActiveStates()
    }

    setActiveStates () {
        const navItems = {}
        Object.keys(this.state.items).map(key => {
            const item = this.state.items[key]
            navItems[key] = item
            navItems[key].active = this.checkActive(item)

            if (item.children) {
                const children = []
                item.children.map(item => {
                    item.active = this.checkActive(item)
                    children.push(item)
                })
                navItems[key].children = children
            }
        })

        this.setState({ items: navItems })
    }

    checkActive (item) {
        let active = ''

        if (item.url !== '/' && window.location.pathname.includes(item.url)) {
            active = 'is-active'
        }

        return active
    }

    render () {
        return (
            <div className='nav-container' id='navigation'>
                {this.props.dontShowPayments ? <NavPayments /> : ( 
                <React.Fragment>
                    <NavDesktop items={this.state.items}/>
                    <NavMobile items={this.state.items}/>
                </React.Fragment>
                )}
            </div>
        )
    }
}

export default Navigation



// WEBPACK FOOTER //
// ./resources/js/layout/Navigation.js